import { useState } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { useSearchParams } from "react-router-dom";

export default function CustomDateRangePicker() {
  const [searchParams, setSearchParams] = useSearchParams();
  const showText = searchParams.get("range") === null;
  const onApply = (e) => {
    searchParams.set("range", e.target.value);
    setSearchParams(searchParams);
  };
  const onCancel = (e) => {
    searchParams.delete("range");
    setSearchParams(searchParams);
  };
  return (
    <div className="input-group">
      <DateRangePicker
        children={<>Button</>}
        onApply={onApply}
        onCancel={onCancel}
        initialSettings={{
          autoUpdateInput: true,
          drops: "down",
          maxDate: new Date(),
          locale: {
            format: "YYYY/MM/DD",
          },
        }}
      >
        {showText ? (
          <input value={"Өдөр сонгох..."} className="form-control" />
        ) : (
          <input type="text" className="form-control" id="dash-daterange" />
        )}
      </DateRangePicker>
      <span className="input-group-text border">
        <i className="mdi mdi-calendar-range font-13" />
      </span>
    </div>
  );
}
